import * as React from "react";
import { ProductInventory } from "../Inventory/ProductInventory/ProductInventory";
import { Product } from "./types";

export type addToCartViewState = "button" | "inventory";

export const AddToCartButton: React.FunctionComponent<{
  item: Product;
  isAddingToCart: boolean;
  onProductAddToCartClick: () => void;
}> = (props) => {
  const [viewState, setViewState] =
    React.useState<addToCartViewState>("inventory");

  const handleInventory = (result: InventoryResult) => {
    if (result.StoreNumber) {
      setViewState("button");
    }
  };

  const productId = props.item.ProductId;
  const sku = props.item.ProductCode;

  if (viewState === "button") {
    return (
      <button
        type="button"
        className={`prod-button ${props.isAddingToCart ? "adding-to-cart" : ""}`}
        title={
          props.isAddingToCart
            ? `Adding ${props.item.Name} to cart`
            : `Add ${props.item.Name} to cart`
        }
        disabled={props.isAddingToCart}
        aria-busy={props.isAddingToCart}
        onClick={(e) => {
          e.preventDefault();
          props.onProductAddToCartClick();
        }}
      >
        {props.isAddingToCart ? "Adding..." : "Add to Order"}
      </button>
    );
  }
  if (viewState === "inventory") {
    return (
      <ProductInventory
        Sku={sku}
        ProductId={productId}
        onInventoryChecked={handleInventory}
      />
    );
  }

  return <></>;
};
